export const language: any ={
    OkLogout: "Yes",
    CloseLogout: "No",
    OkLeave: "Secession",
    CloseLeave: "Cancel",
    LabelPolicy: "Privacy policy",
    AppName: "Hey! Cooker",
    OnOffNotification: "Notification On/Off",
    LabelReceiveNotificationSuggestion: "Receive recipe suggestion notifications",
    LabelReceiveNotifyBreakfast: "Receive daily breakfast recommendations",
    LabelReceiveNotifyLunch: "Receive daily lunch recommendations",
    LabelReceiveNotifyDinner: "Receive daily dinner recommendations",
    notification_history: "Notification History",
    readAll: "Read all",
    no_notification: "No notification history",
    labelDisplayName: "Enter display name",
    placeholderDisplayName: "Enter minimum 4 characters, maximum 20 characters",
    changeDisplayName: "Change display name",
}

